module.exports = __webpack_public_path__ + "img/3b.728cd04.png";